import React from 'react'
import { Map } from 'immutable'
import Button, { TYPES as BUTTON_TYPES } from '../Button/index'
import { historyRedirect } from '../../services/navigation/index'

export const SORT_OPTIONS = ['curated', 'relevance', 'dateAdded', 'popularity', 'az'] as const
export type SortOption = typeof SORT_OPTIONS[number]

// Map UI option keys to REST API sort values (curated has no API value)
const SORT_VALUE_MAP: Record<Exclude<SortOption, 'curated'>, string> = {
  relevance: '',
  dateAdded: 'recent',
  popularity: 'popular',
  az: 'alpha',
}

interface SortBarProps {
  staticText: Map<string, unknown>
  history: Record<string, unknown>
  location: { query?: { q?: string; sort?: string } }
  auth: Map<string, unknown>
  language: string
  sortMode: SortOption
  onSortChange: (sort: SortOption) => void
}

export default function SortBar ({
  staticText,
  history,
  location,
  auth,
  language,
  sortMode,
  onSortChange,
}: SortBarProps): React.ReactElement {
  const q = location.query?.q || ''

  function handleSortClick (option: SortOption) {
    if (option === sortMode || !q) return

    // Always notify parent
    onSortChange(option)

    // Curated is client-only — no URL change
    if (option === 'curated') return

    const apiSort = SORT_VALUE_MAP[option]
    const query: Record<string, string> = { q }
    if (apiSort) {
      query.sort = apiSort
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (historyRedirect as any)({
      history,
      url: '/search',
      query,
      auth,
      language,
    })
  }

  return (
    <div className="ai-guide-search__sort-bar">
      {SORT_OPTIONS.map((option) => {
        const label = staticText.getIn(['data', option], option) as string
        const isActive = sortMode === option
        return (
          <Button
            key={option}
            type={BUTTON_TYPES.GHOST}
            className={
              `ai-guide-search__sort-btn${isActive ? ' ai-guide-search__sort-btn--active' : ''}`
            }
            aria-pressed={isActive}
            onClick={() => handleSortClick(option)}
          >
            {label}
          </Button>
        )
      })}
    </div>
  )
}
